/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  agents:[],
  popup:false,
  agent:{
    key:'',
    digit:0,
    code:0,
    name:'',
    username:'',
    password:'',
    prefix:'',
  }
}